 import React, { useState } from 'react'; 
 import { Modal, DatePicker, message } from 'antd'; 
 import type { Dayjs } from 'dayjs';
 import api from '../utils/api';

const { RangePicker } = DatePicker;

interface ExportStatisticsModalProps 
{
     open: boolean; 
     onCancel: () => void; 
     title?: string; 
     endpoint?: string; // 默认 /api/report-review/statistics/export/ 
     withCredentials?: boolean; // 是否携带 Cookie，默认 true 
}

const ExportStatisticsModal: React.FC<ExportStatisticsModalProps> = ({
    open, 
    onCancel, 
    title = '导出统计', 
    endpoint = '/api/report-review/statistics/export/', 
    withCredentials = true}) => 
{
    const [dateRange, setDateRange] = useState<[Dayjs | null, Dayjs | null]>([null, null]); 
    const [loading, setLoading] = useState(false);

    const handleOk = async () => { 
        const [start, end] = dateRange; 
        if (!start || !end) { 
            message.warning('请选择开始和结束日期'); 
            return; 
        }

        const startStr = start.format('YYYY-MM-DD');
        const endStr = end.format('YYYY-MM-DD');

        setLoading(true);
        try {
            // 用你们统一的 axios 实例发起请求，确保走对后端域名/代理
            const res = await api.get(endpoint, {
                params: { start_time: startStr, end_time: endStr },
                responseType: 'blob',     // 很关键：以二进制下载
                withCredentials: true,    // 如果后端依赖 cookie 会话
            });

            const contentType = (res.headers['content-type'] || '').toLowerCase();
            const isExcel =
                contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') ||
                contentType.includes('application/octet-stream');

            if (!isExcel) {
                // 如果不是 Excel，很可能被重定向到了前端页面或登录页
                let preview = '';
                try {
                    preview = await (res.data as Blob).text();
                } catch {}
                throw new Error(
                    `服务返回的不是 Excel（${contentType || '无 content-type'}）。可能请求未到后端或被重定向。\n响应片段：${preview.slice(0, 200)}`
                );
            }

            // 解析文件名
            const disposition = res.headers['content-disposition'] || res.headers['Content-Disposition'];
            let filename = `report_review_statistics_${startStr}_${endStr}.xlsx`;
            if (disposition) {
                const match1 = disposition.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i);
                const match2 = disposition.match(/filename=["']?([^"']+)["']?/i);
                if (match1?.[1]) {
                    try {
                        filename = decodeURIComponent(match1[1]);
                    } catch {}
                } else if (match2?.[1]) {
                    filename = match2[1];
                }
            }

            // 触发下载
            const blobUrl = window.URL.createObjectURL(res.data as Blob);
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(blobUrl);

            message.success('导出成功');
            onCancel(); // 导出成功后关闭弹窗
        } catch (e: any) {
        message.error(e?.message || '导出失败');
        } finally {
            setLoading(false);
        }
    };

return ( 
    <Modal 
        open={open} 
        title={title} 
        onCancel={() => !loading && onCancel()} 
        onOk={handleOk} okText="导出" 
        cancelText="取消" 
        confirmLoading={loading} 
        maskClosable={!loading} 
        destroyOnClose > 
            <RangePicker 
                allowClear 
                format="YYYY-MM-DD" 
                value={dateRange} 
                onChange={(dates) => setDateRange(dates as [Dayjs | null, Dayjs | null])} 
                style={{ width: '100%' }} 
                placeholder={['开始日期', '结束日期']} /> 
                    <div style={{ marginTop: 8, color: '#999' }}> 选择时间范围后点击“导出”下载 Excel 文件。 </div> 
    </Modal> ); 
};

export default ExportStatisticsModal;